module.exports = __webpack_public_path__ + "img/ic_dashboard.b426afdf.svg";